export default "__VITE_ASSET__2a6a1ff4__"